module.exports = __webpack_public_path__ + "img/MT.21158c5f.svg";